import { render, staticRenderFns } from "./workOrder-task.vue?vue&type=template&id=0b89ae9f&scoped=true&"
import script from "./workOrder-task.vue?vue&type=script&lang=js&"
export * from "./workOrder-task.vue?vue&type=script&lang=js&"
import style0 from "./workOrder-task.vue?vue&type=style&index=0&id=0b89ae9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89ae9f",
  null
  
)

component.options.__file = "workOrder-task.vue"
export default component.exports